<template>
  <div v-if="rows.length" class="mb-6 overflow-hidden rounded-lg border border-gray-200">
    <table class="w-full text-sm">
      <caption v-if="title" class="bg-gray-50 px-4 py-3 text-left text-base font-semibold text-gray-900">
        {{ title }}
      </caption>
      <tbody>
        <tr
          v-for="(row, index) in rows"
          :key="index"
          :class="row.separated ? 'border-t-2 border-gray-200 bg-gray-50' : 'border-t border-gray-100'"
        >
          <th scope="row" class="px-4 py-2.5 text-left font-medium text-gray-700">{{ row.label }}</th>
          <td class="px-4 py-2.5 text-right whitespace-nowrap">
            <span class="font-semibold tabular-nums text-gray-900">{{ row.value }}</span>
            <span v-if="unit" class="ml-1 text-xs text-gray-500">{{ unit }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// Price grid: labels on the left, prices right-aligned with tabular figures. A `separated` row
// (e.g. a flat-rate offer) is set apart from the bands above it.
export default {
  name: "PriceTable",
  props: {
    title: { type: String, default: "" },
    unit: { type: String, default: "" },
    rows: { type: Array, default: () => [] },
  },
};
</script>
